import Stack from '@mui/material/Stack';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EmptyState } from '@radiology/ui';
import { Danger } from 'iconsax-react';
import { MODULE_DEFINITIONS } from './navigation';

/**
 * Full-page status screens.
 *
 * Kept in their own module because both the router and ModuleLayout render
 * them; importing them from router.tsx would make ModuleLayout <-> router a
 * cycle.
 */

export function NoAccessPage({ moduleKey }: { moduleKey?: string }) {
  const params = useParams<{ module?: string }>();
  const navigate = useNavigate();
  const key = moduleKey ?? params.module;
  const label = MODULE_DEFINITIONS.find(m => m.key === key)?.label;

  return (
    <Stack sx={{ minHeight: '100dvh' }} justifyContent="center">
      <EmptyState
        variant="page"
        icon={<Danger size={26} color="currentColor" />}
        title={label ? `No access to ${label}` : 'No access'}
        description={
          label
            ? `Your account has no role in ${label}. Ask an administrator to assign one if you need it.`
            : 'Your account has no role in any module of the portal. Contact an administrator.'
        }
        action={{ label: 'Back to portal', onClick: () => void navigate('/') }}
      />
    </Stack>
  );
}

export function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Stack sx={{ minHeight: '100dvh' }} justifyContent="center">
      <EmptyState
        variant="page"
        title="Page not found"
        description={`Nothing is routed at ${location.pathname}.`}
        action={{ label: 'Back to portal', onClick: () => void navigate('/') }}
      />
    </Stack>
  );
}

/** Placeholder until Phase 3 builds the real login + email-OTP flow. */
export function LoginPage() {
  const navigate = useNavigate();
  return (
    <Stack sx={{ minHeight: '100dvh' }} justifyContent="center">
      <EmptyState
        variant="page"
        title="Sign in"
        description="The login and email-OTP flow is built in Phase 3. Until then the app runs on a local development session."
        action={{ label: 'Continue to portal', onClick: () => void navigate('/') }}
      />
    </Stack>
  );
}
